import React from 'react';

const ButtonActionMenu = (props) => {
  const { text = null, button1 = null, button2 = null } = props;

  if (text != null) {
    return (
      <div className="text-nowrap">
        <span>{text}</span>
      </div>
    );
  }

  if (button1 != null) {
    button1.button = () => {
      return (
        <button type="button" className="btn btn-success btn-sm mt-1 mx-1" onClick={button1.onClick}>
          {button1.text}
        </button>
      );
    };
  }

  if (button2 != null) {
    button2.button = () => {
      return (
        <button className="btn btn-danger btn-sm mt-1 mx-1" onClick={button2.onClick}>
          {button2.text}
        </button>
      );
    };
  }

  return (
    <div>
      {button1 ? button1.button() : <></>}
      {button2 ? button2.button() : <></>}
    </div>
  );
};

export default ButtonActionMenu;
